<template>
  <div>
    <div class="dldeing">修 改 密 码</div>
    <div class="pin">
      <van-field v-model="value" placeholder="请输入原密码" />
      <van-field
        type="password"
        v-model="value1"
        placeholder="请输入新密码（6-20位英文或数字）"
        style="margin-top: 10px"
      />
      <van-field
        type="password"
        v-model="value2"
        placeholder="请再次输入新密码（6-20位英文或数字）"
        style="margin-top: 10px"
      />
      <van-field disabled style="display: none" />
      <!-- <span class="waspan">忘记密码？</span> -->
      <div class="dlanniu" @click="dian">确 认</div>
    </div>
  </div>
</template>
<script>
import { usercenterpassword } from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      value: "",
      value1: "",
      value2: "",
    };
  },
  watch: {},
  components: {},
  methods: {
    dian() {
        let that=this
      if (this.value == "") {
        Toast("请输入原密码");
        return false;
      }
      if (this.value1 == "") {
        Toast("请输入新密码");
        return false;
      }
      if (this.value2 == "") {
        Toast("请再次输入新密码");
        return false;
      }
      if (this.value2 !== this.value1) {
        Toast("两次密码输入不一致，请重新输入！");
        return false;
      }
      if(this.value2.length<6){
          Toast("新密码为6-20位英文或数字！");
        return false;
      }
      let params = {
        oldPassword: this.value,
        newPassword: this.value1,
      };
      usercenterpassword(params)
        .then((res) => {
          if (res.data.code !== "0") {
            Toast(res.data.msg);
          } else {
            Toast("修改成功,下次登陆失效");
            setTimeout(function () {
              that.$router.go(-1);
            }, 1000);
          }
        })
        .catch((rdd) => {});
    },
  },
  mounted() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/my/password.vue